import config from '../apps/config.js';
import {
	parseQueryString
} from './utils.js';
let thirdparty = {
	getDomainParams: () => {
		const me = this;
		let domain = document.domain;
		//var domain2 = window.location.host;
		//console.log(domain) //localhost
		//console.log(domain2) //localhost:3000
		const url = window.location.href;
		const urlparams = parseQueryString(url);
		let access_token = urlparams.get('access_token');
		let access_userid = urlparams.get('access_userid');
		let scope = urlparams.get('scope');

		if (typeof (access_token) != 'undefined' && access_token.length) {
			access_token = access_token.replace(/#/g, '').replace(/\//g, '');
		}
		if (typeof (access_userid) != 'undefined' && access_userid.length) {
			access_userid = access_userid.replace(/#/g, '').replace(/\//g, '');
		}
		if (typeof (scope) != 'undefined' && scope.length) {
			scope = scope.replace(/#/g, '').replace(/\//g, '');
		}

		return {
			type: 'companyinfo',
			domain: domain,
			access_token: access_token || '',
			access_userid: access_userid || '',
			scope: scope || ''
		}

	},
	getCompany: () => {
		const me = this;

		let onInitialSubject = new Promise(function (resolve, reject) {

			let postdata = thirdparty.getDomainParams();
			console.log(postdata);
			fetch(config.host + '/company/index', {
				method: 'post',
				body: JSON.stringify(postdata)
			})
				.then(res => res.json())
				.then(json => {
					console.log(json)
					if (json.status == 1) {

						if (typeof json.company_detail != 'undefined') {
							localStorage.company_detail = JSON.stringify(json.company_detail);
						}

						localStorage.clear();
						localStorage.token = json.user.token;
						localStorage.typestyle = json.user.typestyle;
						localStorage.user = JSON.stringify(json.user.userinfo);

						resolve(json);
					} else {
						reject(json);
					}
				})
				.catch(error => {
					console.log(error);
					reject(error);
				});
		});
		return onInitialSubject;
		// onInitialSubject.then((res) => {
		// 	// this.createPetMrOrPetCtOrPet();
		// });

	}

};

export default thirdparty;


// WEBPACK FOOTER //
// ./src/utils/thirdparty.js